/**
 * Re-init Okendo Widget Plus stars after Advanced Commerce / GrapheneHC cards render.
 * Support guidance: call window.okeWidgetApi.initAllWidgets() once cards are in the DOM.
 */

let plpOkendoObserverInitialized = false;
let plpOkendoApiWaitTimer = null;

function whenOkeWidgetApiReady(callback) {
  if (
    window.okeWidgetApi &&
    (typeof window.okeWidgetApi.initAllWidgets === 'function' ||
      typeof window.okeWidgetApi.initWidget === 'function')
  ) {
    callback();
    return;
  }

  if (plpOkendoApiWaitTimer) return;

  let attempts = 0;
  plpOkendoApiWaitTimer = window.setInterval(() => {
    attempts += 1;
    if (
      window.okeWidgetApi &&
      (typeof window.okeWidgetApi.initAllWidgets === 'function' ||
        typeof window.okeWidgetApi.initWidget === 'function')
    ) {
      window.clearInterval(plpOkendoApiWaitTimer);
      plpOkendoApiWaitTimer = null;
      callback();
      return;
    }
    if (attempts >= 50) {
      window.clearInterval(plpOkendoApiWaitTimer);
      plpOkendoApiWaitTimer = null;
    }
  }, 100);
}

function initPlpOkendoStars() {
  whenOkeWidgetApiReady(() => {
    try {
      if (typeof window.okeWidgetApi.initAllWidgets === 'function') {
        window.okeWidgetApi.initAllWidgets();
        return;
      }

      // Fallback if initAllWidgets is unavailable on this Okendo build
      const holders = document.querySelectorAll(
        '.prd-Card_Review [data-oke-star-rating][data-oke-reviews-product-id]:not([data-oke-rendered])'
      );
      for (const holder of holders) {
        window.okeWidgetApi.initWidget(holder, true);
      }
    } catch (error) {
      console.error('Okendo PLP initAllWidgets failed:', error);
    }
  });
}

function debouncePlpOkendoInit(fn, wait) {
  let timeoutId;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => fn(...args), wait);
  };
}

const debouncedInitPlpOkendoStars = debouncePlpOkendoInit(initPlpOkendoStars, 200);

function initAcPlpOkendoObserver() {
  if (plpOkendoObserverInitialized) return;

  const targets = document.querySelectorAll(
    '.acs_collection_results, .acs_search_results, .acs_results'
  );
  if (!targets.length) return;

  plpOkendoObserverInitialized = true;

  for (const target of targets) {
    const observer = new MutationObserver(() => {
      debouncedInitPlpOkendoStars();
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  initPlpOkendoStars();
}

document.addEventListener('swym:collections-loaded', initPlpOkendoStars);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAcPlpOkendoObserver, { once: true });
} else {
  initAcPlpOkendoObserver();
}

window.initPendingPlpOkendoStars = initPlpOkendoStars;
window.initPlpOkendoStars = initPlpOkendoStars;
